import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addAfterLoginNotification } from "../../../components/Toast/utils/notifications";
import * as services from "../services";

interface AsyncState {
  isLoading: {
    mainBannerData: boolean;
    addBanners: boolean;
    updateBanners: boolean;
    brandAdd: boolean;
    deleteBanner: boolean;
  };
  isSuccess: boolean;
  isErrored: boolean;
}

interface TableState extends AsyncState {
  mainBannerData: any;
  isLogout: any;
  errorMsg: any;
  addBanners: any;
  deleteBanner: any;
  updateBanners: any;
}

const initialState: TableState = {
  isLoading: {
    mainBannerData: false,
    addBanners: false,
    updateBanners: false,
    brandAdd: false,
    deleteBanner: false,
  },
  addBanners: null,
  isSuccess: false,
  isErrored: false,
  mainBannerData: null,
  updateBanners: null,
  deleteBanner: null,
  isLogout: false,
  errorMsg: null,
};

export const fetchAllBanners = createAsyncThunk(
  "bannerdata",
  async (data: any, thunkAPI) => {
    try {
      const res: any = await services.getAllBanners();
      return { fullResponse: res.data };
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const addbanners = createAsyncThunk(
  "banner/addbanners",
  async (data: any, thunkAPI) => {
    try {
      return await services.addBanners(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateBanner = createAsyncThunk(
  "banner/updateBanner",
  async (data: any, thunkAPI) => {
    try {
      const res = await services.updateBanners(data);
      console.log("res", res);
      return res;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteBanner = createAsyncThunk(
  "banner/deleteBanner",
  async (data: any, thunkAPI) => {
    try {
      const res = await services.deleteBanner(data);
      return res;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const bannerSlice = createSlice({
  name: "banner",
  initialState,
  reducers: {
    reset: (state) => {
      state.isSuccess = false;
      state.addBanners = {};
      state.deleteBanner = {};
      state.updateBanners = {};
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllBanners.pending, (state) => {
        state.isLoading.mainBannerData = true;
        state.isSuccess = false;
        state.isErrored = false;
      })
      .addCase(fetchAllBanners.fulfilled, (state, action) => {
        state.isLoading.mainBannerData = false;
        state.isSuccess = true;
        state.isErrored = false;
        state.mainBannerData = action.payload.fullResponse;
        state.errorMsg = null;
      })
      .addCase(fetchAllBanners.rejected, (state) => {
        state.isLoading.mainBannerData = false;
        state.isSuccess = false;
        state.isErrored = true;
      })

      .addCase(addbanners.pending, (state) => {
        state.isLoading.addBanners = true;
        state.isSuccess = false;
        state.isErrored = false;
      })
      .addCase(addbanners.fulfilled, (state, action: any) => {
        addAfterLoginNotification("Banner Create successfully", "success");
        state.isLoading.addBanners = false;
        state.isSuccess = true;
        state.isErrored = false;
        state.addBanners = action.payload;
        state.errorMsg = null;
      })
      .addCase(addbanners.rejected, (state, action: any) => {
        addAfterLoginNotification(action.payload.errorMsg, "error");
        state.isLoading.addBanners = false;
        state.isSuccess = false;
        state.isErrored = true;
        state.errorMsg = action.payload.errorMsg;
      })

      .addCase(updateBanner.pending, (state) => {
        state.isLoading.updateBanners = true;
        state.isSuccess = false;
        state.isErrored = false;
      })
      .addCase(updateBanner.fulfilled, (state, action: any) => {
        addAfterLoginNotification("Banner Update successfully", "success");
        state.isLoading.updateBanners = false;
        state.isSuccess = true;
        state.isErrored = false;
        state.updateBanners = action.payload;
        state.errorMsg = null;
      })
      .addCase(updateBanner.rejected, (state, action: any) => {
        addAfterLoginNotification(action.payload.errorMsg, "error");
        state.isLoading.updateBanners = false;
        state.isSuccess = false;
        state.isErrored = true;
        state.errorMsg = action.payload.errorMsg;
      })
      
      .addCase(deleteBanner.pending, (state) => {
        state.isLoading.deleteBanner = true;
        state.isSuccess = false;
        state.isErrored = false;
      })
      .addCase(deleteBanner.fulfilled, (state, action: any) => {
        addAfterLoginNotification("Banner Delete successfully", "success");
        state.isLoading.deleteBanner = false;
        state.isSuccess = true;
        state.isErrored = false;
        state.deleteBanner = action.payload;
        state.errorMsg = null;
      })
      .addCase(deleteBanner.rejected, (state, action: any) => {
        addAfterLoginNotification(action.payload.errorMsg, "error");
        state.isLoading.deleteBanner = false;
        state.isSuccess = false;
        state.isErrored = true;
        state.errorMsg = action.payload.errorMsg;
      });
  },
});

export const { reset } = bannerSlice.actions;
export default bannerSlice.reducer;
